import React from 'react';
import PropTypes from 'prop-types';
import { lowerCase } from 'lodash';

const ListGroupItemTreatmentReferral = ({ data }) => (
  <span className="ml-2">
    {data.relationships.referenceStatus &&
      (data.relationships.referenceStatus.attributes.statusLabel)}{data.attributes.statusLabel}{' to treatment'}
    {data.attributes.facilityName &&
        ` at ${data.attributes.facilityName}`}
    {data.relationships.facility &&
        ` at ${data.relationships.facility.attributes.facilityName}`}
    {data.attributes.reasonLabel &&
        ` for ${lowerCase(data.attributes.reasonLabel)}`}
    {data.relationships.referenceReason &&
        ` for ${lowerCase(data.relationships.referenceReason.attributes.reasonName)}`}
        .
  </span>
);

ListGroupItemTreatmentReferral.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ListGroupItemTreatmentReferral;
